module.exports = __webpack_public_path__ + "static/img/file.d39bde12.svg";